// extracted by mini-css-extract-plugin
module.exports = {"icon":"listNode_icon__3SSH4","name-container":"listNode_name-container__3pOIm"};